// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route } from 'react-router-dom'

// Internal Dependencies:
import DisclaimerConsent from 'components/DisclaimerConsent/DisclaimerConsent'
import HeaderPrimary from 'components/HeaderPrimary/HeaderPrimary'
import HeaderMobilePrimary from 'components/HeaderPrimary/HeaderMobilePrimary'
import Menu from 'components/menu/menu'
import Footer from 'components/Footer/Footer'
import HomeLayout from 'layouts/HomeLayout'
import MainLayout from 'layouts/MainLayout'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'

// Redux:
import { getScreenSize, getPeopleData } from 'actions/site'

const siteImage = siteData.site_featured_image_url
const siteImageSrcset = siteData.site_featured_image_srcset

class SiteLayout extends React.Component {
	componentDidMount() {
		window.addEventListener( 'resize', this.onResize )

		this.props.dispatch( getPeopleData() )
	}

	onResize = () => {
		this.props.dispatch( getScreenSize() )
	}

	render() {
		const { isMobile, siteId, hasSidebar, page, location, match, disclaimerConsent } = this.props
		let className = '/' == location.pathname ? 'site-wrap is-home' : 'site-wrap'

		// Cookie consent:
		if ( null === disclaimerConsent ) {
			className += ' with-disclaimer-consent-bar'
		}

		return (
			<div className={ className }>
				<div className="site">
					<DisclaimerConsent />
					<HeaderMobilePrimary />

					<div className="main-wrap">
						<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

						<HeaderPrimary match={ match } />

						<section className="main">
							<Switch>
								<Route path="/" exact component={ HomeLayout } />
								<Route path="/:page" exact component={ MainLayout } />
								<Route path="/video/:video" exact component={ MainLayout } />
								<Route path="/videos/:video" exact component={ MainLayout } />
								<Route path="/:parent/:page" exact component={ MainLayout } />
								<Route component={ MainLayout } />
							</Switch>
						</section>
					</div>
				</div>

				<Footer />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isMobile: state.site.isMobile,
		hasSidebar: state.site.hasSidebar,
		disclaimerConsent: state.site.disclaimerConsent,
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( SiteLayout )



// WEBPACK FOOTER //
// ./layouts/SiteLayout.jsx